import { useEffect, useRef, useState } from "react";
import { useShowAlert } from "../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "./font/Inter_24pt-Regular-normal";
import InterBold from "./font/Inter_24pt-Bold-normal";
import { useNavigate } from "react-router-dom";
import Messages from "../constants/Messages";
import AxiosInstance from "../utils/AxiosInstance";
import handleError from "../constants/handleError";
import uRLs from "../utils/baseUtils";
import { formatCurrency } from "@heartinz/finance";
import { FormatedSaleData } from "../utils/GloabalSaleData";
import QRCode from "qrcode";
import InvoiceLayout from "./common/InvoiceLayout ";
import InvoiceWrapper from "./common/InvoiceWrapper";

const CommercialInvoice = ({ isData }) => { 
 
  const [data, setData] = useState({});
  const terms =
  isData?.storeSettings?.invoiceSettings?.termsAndConditions;
  const globalData = FormatedSaleData(data);
  const [download, setDownload] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");

  const selectedTheme =
  isData?.storeSettings?.invoiceSettings?.template;

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  //
  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  const generateInvoice1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    // console.log("storeSettings?.negobillBranding",storeSettings?.negobillBranding)
    // Header Logic
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const COL_RIGHT = pageW - 65;
    const COL_MIDDLE = pageW / 2.8;
    let y = PADDING + 5;

    const invoiceText =
      globalData?.status === "CANCELLED" ? "CANCELLED" : "TAX INVOICE";
    const originalText = "ORIGINAL FOR RECIPIENT";
    function drawSpacedText(doc, text, x, y, spacing = 0.8) {
      let cursorX = x;
      for (const ch of text) {
        doc.text(ch, cursorX, y);
        cursorX += doc.getTextWidth(ch) + spacing;
      }
    }
    // --- Row 1: Header Titles ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(14);
    doc.setTextColor(20, 40, 100); // Navy blue for "TAX INVOICE"
    // doc.text(invoiceText, MARGIN_LEFT, y);
    drawSpacedText(doc, invoiceText, MARGIN_LEFT, y, 0.6);

    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90); // Gray
    // doc.text(originalText, MARGIN_RIGHT, y, { align: "right" });
    const textWidth = originalText
      .split("")
      .reduce((w, ch) => w + doc.getTextWidth(ch) + 0.6, 0);

    drawSpacedText(doc, originalText, MARGIN_RIGHT - textWidth, y, 0.6);

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode
    );

    // --- Row 2: Seller Info & Logo ---
    y = 20;
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(globalData?.salefrom?.title || "", MARGIN_LEFT, y);

    // Placeholder for Logo (Replace with doc.addImage(base64, 'PNG', x, y, w, h))
    doc.setFontSize(22);
    doc.setTextColor(34, 139, 34); // DMart Green
    if (globalData?.salefrom?.image) {
      try {
        const imagePath =
          uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;

        // const imagePath = settings?.saleProfileData?.image ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png";
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 40;
        const maxHeight = 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);

        const finalW = imgW * ratio;
        const finalH = imgH * ratio;

        const ext = imagePath.split(".").pop().toLowerCase();
        const format = ext === "png" ? "PNG" : "JPEG";
        const logoX = MARGIN_RIGHT - finalW;
        // Use finalW and finalH instead of maxWidth and maxHeight
        doc.addImage(base64, format, logoX, y, finalW, finalH);
        // doc.addImage(base64, format, pageW - 60, y - 5, maxWidth, maxHeight);
      } catch (err) {
        console.warn("Logo load failed:", err);
        // Fallback text if logo fails
        doc.setFontSize(22);
        doc.setTextColor(34, 139, 34);
        doc.text("Test-Store", MARGIN_RIGHT, y + 5, { align: "right" });
      }
    }

    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(0);
    y += 6;
    doc.text(`GSTIN: ${globalData?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
    y += 4;
    doc.setFont("Inter-Regular", "normal");
    const addressWidth = pageW / 2 - MARGIN_LEFT - 5;
    const addressLines = doc.splitTextToSize(address, addressWidth);
    doc.text(addressLines, MARGIN_LEFT, y);
    y += addressLines.length * 4;

    doc.text(`Mobile: ${globalData?.salefrom?.phone || ""}`, MARGIN_LEFT, y);
    doc.setFont("Inter-Bold", "bold");
    // Check for PAN
    if (globalData?.salefrom?.pannumber) {
      y += 4;
      doc.text(`PAN: ${globalData.salefrom.pannumber}`, MARGIN_LEFT, y);
    }

    // Check for FSSAI
    if (globalData?.salefrom?.fassi) {
      y += 4;
      doc.text(`FSSAI: ${globalData.salefrom.fassi}`, MARGIN_LEFT, y);
    }

    // Check for CIN
    if (globalData?.salefrom?.cinnumber) {
      y += 4;
      doc.text(`CIN: ${globalData.salefrom.cinnumber}`, MARGIN_LEFT, y);
    }

    doc.setFont("Inter-Regular", "normal");
    // --- Row 3: Invoice Meta Data ---
    // y += 5;
    doc.setDrawColor(200);

    // doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);// Thin separator line
    y += 5;
    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;

    y += 4;
    const startYAddress = y;

    doc.setFont("Inter-Bold", "bold");
    // doc.text(`Invoice #: ${ data.saleno || ''}`, 10, y);
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Invoice #: ", MARGIN_LEFT, y);
    let invNoX = 10 + doc.getTextWidth("Invoice #: ");

    doc.setFontSize(10);
    doc.text(`${globalData.saleno || ""}`, invNoX, y);

    // doc.text(`Invoice Date: ${invDate || ''}`, pageW / 2.8, y);
    doc.setFontSize(9);
    const dateLabel = "Invoice Date: ";
    const dateX = pageW / 2.8;
    doc.setFont("Inter-Bold", "bold");
    doc.text(dateLabel, dateX, y);
    let dateValX = dateX + doc.getTextWidth(dateLabel);
    doc.setFontSize(10);
    doc.text(`${invDate || ""}`, dateValX, y);

    doc.setFontSize(9);

    // doc.text(`Due Date: ${invDate || ''}`, pageW - 60, y);
    const rightX = pageW - 65;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Invoice Time: ", rightX, y);
    let dueX = rightX + doc.getTextWidth("Invoice Time: ");
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(10);
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, timezone)
    ).time;
    doc.text(`${invDateTime || ""}`, dueX, y);
    const customerAddress = [
      [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.country,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", "),

      // [data?.saleto?.district, data?.saleto?.state, data?.saleto?.pincode].filter(Boolean).join(", ")
    ].join("\n");
    const hasCustomer = !!globalData?.saleto;
    const hasAddress = !!customerAddress;
    const rowStartY = hasCustomer || hasAddress ? y + 5 : y;
    let maxColumnY = rowStartY;

    // Helper to draw Bold Label and Normal Value
    const drawLabelValue = (label, value, x, currentY) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(`${label}: `, x, currentY);
      const labelWidth = doc.getTextWidth(`${label}: `);
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value), x + labelWidth, currentY);
    };

    const colWidth = 55; // Same for Billing and Shipping
    const lineStep = 4; // Standard vertical spacing for lines
    let col1X = MARGIN_LEFT;
    let col2X = pageW / 2.8;
    let col3X = pageW - 65;
    if (!hasCustomer) {
      col2X = MARGIN_LEFT;
      col3X = pageW / 2;
    }

    // 🔥 If only one column → full width feel
    if (hasCustomer && !hasAddress) {
      col2X = pageW / 2;
    }

    let col1Y = rowStartY;
    doc.setFontSize(9);
    // && storeSettings?.saleSettings?.isCustomerDisplay
    if (hasCustomer ) {
      doc.setFont("Inter-Regular", "normal");
      doc.text("Customer Details:", MARGIN_LEFT, col1Y);
      col1Y += 5;

      doc.setFont("Inter-Bold", "bold");
      const customerName = globalData?.saleto?.name || "-";
      const nameLines = doc.splitTextToSize(customerName, colWidth);
      doc.text(nameLines, MARGIN_LEFT, col1Y);
      col1Y += nameLines.length * lineStep;

      doc.setFont("Inter-Regular", "normal");
      doc.text(`Ph: ${globalData?.saleto?.phone || ""}`, MARGIN_LEFT, col1Y);

      if (globalData?.saleto?.gstnumber) {
        col1Y += 4;
        drawLabelValue(
          "GSTIN",
          globalData.saleto.gstnumber,
          MARGIN_LEFT,
          col1Y
        );
      }
      if (globalData?.saleto?.fassi) {
        col1Y += 4;
        drawLabelValue("FSSAI", globalData.saleto.fassi, MARGIN_LEFT, col1Y);
      }
      if (globalData?.saleto?.pannumber) {
        col1Y += 4;
        drawLabelValue("PAN", globalData.saleto.pannumber, MARGIN_LEFT, col1Y);
      }
      if (globalData?.saleto?.cinnumber) {
        col1Y += 4;
        drawLabelValue("CIN", globalData.saleto.cinnumber, MARGIN_LEFT, col1Y);
      }
    }
    /* --- COLUMN 2: Billing Address --- */
    let col2Y = rowStartY;
// && storeSettings?.saleSettings?.isCustomerDisplay
    if (hasAddress ) {
      doc.setFont("Inter-Regular", "normal");
      doc.text("Billing address:", col2X, col2Y);
      col2Y += 5;

      const billLines = doc.splitTextToSize(customerAddress || "-", colWidth);
      doc.text(billLines, col2X, col2Y);
      col2Y += billLines.length * lineStep; // Actual dynamic height
    }
    /* --- COLUMN 3: Shipping Address --- */
    let col3Y = rowStartY;
    // Slightly adjusted for margin
    if (hasAddress) {
      doc.setFont("Inter-Regular", "normal");
      doc.text("Shipping address:", col3X, col3Y);
      col3Y += 5;

      const shipLines = doc.splitTextToSize(customerAddress || "-", colWidth);
      doc.text(shipLines, col3X, col3Y);
      col3Y += shipLines.length * lineStep; // Actual dynamic height
    }
    // --- THE FIX: Find the absolute lowest point of all 3 columns ---
    // maxColumnY = Math.max(col1Y, col2Y, col3Y);
    maxColumnY = Math.max(
      hasCustomer ? col1Y : rowStartY,
      hasAddress ? col2Y : rowStartY,
      hasAddress ? col3Y : rowStartY
    );
    /* --- PLACE OF SUPPLY --- */

    y = maxColumnY + 6;
    if (
      globalData?.saleto?.state
    ) {
      doc.setFontSize(10);
      doc.setFont("Inter-Regular", "normal");
      doc.text("Place Of Supply: ", MARGIN_LEFT, y);
      const supplyWidth = doc.getTextWidth("Place Of Supply: ");
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(globalData?.saleto?.state || "-", MARGIN_LEFT + supplyWidth, y);

      // Final safety margin before table
      y += 4;
    }
    const leftBoxX = 8;

    /* -------------------------------------------------
         PRODUCT TABLE
      ------------------------------------------------- */
    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { top: PADDING, left: PADDING, right: PADDING, bottom: PADDING }, // Balanced margins for symmetry
      // tableWidth: 'auto',
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 2, // Extra vertical padding for clarity
        valign: "middle",
        lineHeight: 1.5,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        textColor: [0, 0, 0], // True black text
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 9,
        // textColor: [0, 0, 0],
        // fillColor: false,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100], // Navy blue fill
        textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
        lineWidth: { top: 0.1, bottom: 0.1 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
      },
      head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
      body: globalData.saleitems.map((it, i) => {
        // Exact Item + HSN formatting like image_f6047a.png
        const itemDesc = it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC" : "HSN"}: ${
              it.hsnsac
            }`
          : it.title;
        const amount = it.lineGrandTotal;
        const mrp = it.mrp;
        const baseprice = it.baseprice;
        return [
          i + 1,
          itemDesc,
          `₹${mrp}`,
          `₹${baseprice}`,
          `${it.quantity} `, //Pcs
          `₹${amount}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        // Header alignment
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
            data.cell.styles.halign = "right";
        }

        // Body row styling
        if (data.section === "body") {
          // Light gray divider lines
          data.cell.styles.lineWidth = { bottom: 0.1 };
        }
      },
    });

    y += 3;

    const igst = globalData?.igstamount;
    const sgst = globalData?.sgstamount;
    const cgst = globalData?.cgstamount;
    const linetotalbaseprice = globalData?.totalbaseprice;
    const grantotal = globalData?.grandtotal;
    const paidamount = globalData?.paidamount;

    /* -------------------------------------------------
       TOTALS & GST SECTION (Right Side)
    ------------------------------------------------- */
    y = doc.lastAutoTable.finalY + 5; // Start after the table

    // 1. Grand Total Row
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(12);

    const totalTextX = 140;
    const totalValueX = 200; // This is your right-aligned anchor

    doc.text("Total", totalTextX, y);
    doc.text(`₹${grantotal}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    // FIX: The line must end exactly at 200 to match your text alignment
    y += 2;
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    doc.setLineWidth(0.1);
    doc.line(totalTextX, y, MARGIN_RIGHT, y); // Line now matches text width perfectly
    // 2. Tax Breakdown
    y += 6;
    // doc.setFont("Inter-Regular", "normal");
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    // doc.setTextColor(0);
    doc.setTextColor(48, 48, 48); // #303030
    const isInterState =
      globalData?.salefrom?.statecode &&
      globalData?.saleto?.statecode &&
      globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;

    const summaryData = [["Total Amount Before Tax", `₹${linetotalbaseprice}`]];
    if (isInterState) {
      summaryData.push(["IGST", `₹${igst}`]);
    } else {
      summaryData.push(["CGST", `₹${cgst}`]);
      summaryData.push(["SGST", `₹${sgst}`]);
    }
    summaryData.forEach(([label, value]) => {
      doc.text(label, 140, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 5;
    });
    doc.setTextColor(64, 64, 64);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    doc.text(`Total Items  : ${globalData?.totalItems || 0} `, 10, y);
    doc.setTextColor(0);
    const amountWords = globalData?.amountinwords || "";
    doc.text(`Total Amount (In Words): ${amountWords}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    y += 2;
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);

    // doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.1);
    doc.line(PADDING, y, MARGIN_RIGHT, y);

    y += 5;

    doc.setTextColor(0);
    const footerStartY = y;
    doc.setFontSize(9);

    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(32, 32, 32);
    y = footerStartY;
    const balanceDue = grantotal - paidamount;
    const payX = 140;
    const payments = [
      ["Amount Payable:", `₹${globalData?.balanceDue}`],
      ["Amount Paid:", `₹${paidamount}`],
    ];

    payments.forEach(([label, value]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.text(label, payX, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 4;
    });

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);
    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");
    let neededFooterHeight = 0;
    if (cashAmt > 0) neededFooterHeight += 4;
    if (upiAmt > 0) neededFooterHeight += 4;
    if (cardAmt > 0) neededFooterHeight += 4;
    if (onlineAmt > 0) neededFooterHeight += 4;

    neededFooterHeight += 35;
    if (y + neededFooterHeight > pageH - 20) {
      doc.addPage();
      y = PADDING + 5;
    }
    doc.setFontSize(8);
    y += 2;
    doc.setFont("Inter-Bold", "bold");
    if (globalData?.cashPaid > 0) {
      const cashText = `₹${globalData?.cashPaid} Paid via Cash `;
      doc.text(cashText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.upiPaid > 0) {
      y += 4;
      const upiText = `₹${globalData?.upiPaid} Paid via UPI `;
      doc.text(upiText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.cardPaid > 0) {
      y += 4;
      const cardText = `₹${globalData?.cardPaid} Paid via Card `;
      doc.text(cardText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.onlinePaid > 0) {
      y += 4;
      const onlineText = `₹${globalData?.onlinePaid} Paid Online `;
      doc.text(onlineText, MARGIN_RIGHT, y, { align: "right" });
    }

    y += 10;
    const footerBlockHeight = 25;
    const spaceRemaining = pageH - y;

    // If remaining space is less than the footer height, jump to a new page
    if (spaceRemaining < footerBlockHeight) {
      doc.addPage();
      y = PADDING + 5;
    }
    const currentY = y;

    const paymentSettings = globalData?.storeSettings?.paymentSettings;

    const upiId = paymentSettings?.upiId || "";
    const payeeName = paymentSettings?.bankDetails?.beneficiaryName || "";
    const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      payeeName
    )}&cu=INR`;
    const hasUpi = upiId && upiId.trim().length > 0;
    const bankX = hasUpi ? 45 : PADDING;
    // console.log("bankX", bankX);
    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");

    if (upiId && upiId.trim() !== "") {
      let footerY = y;
      doc.text("Pay using UPI:", PADDING - 2, footerY);
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      const qrX = PADDING - 2;
      const qrY = footerY + 2;
      const qrSize = 25;
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, qrY, qrSize, qrSize);
    }

    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");
    let bankY = currentY + 5;
    if (paymentSettings?.bankDetails) {
      doc.text("Bank Details:", bankX, currentY);

      const bankDetails = [
        ["Bank:", paymentSettings?.bankDetails?.ifscbankName || ""],
        ["Account #:", paymentSettings?.bankDetails?.accountNo || ""],
        ["IFSC:", paymentSettings?.bankDetails?.ifsc || ""],
        ["Branch:", paymentSettings?.bankDetails?.branch || ""],
      ];

      bankDetails.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, bankX, bankY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value), bankX + 20, bankY);
        bankY += 5;
      });
    }

    let sigY = currentY;
    const rightX1 = 202;

    doc.setFontSize(6);
    let actualImgH = 0;
    let signBlockY = sigY;
    if (globalData?.storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + globalData?.storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 35;
        const maxHeight = 20;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          MARGIN_RIGHT - imgW + 3,
          signBlockY,
          imgW,
          imgH
        );
      } catch {
        console.warn("Signature load failed");
      }
    }
    // sigY += 25;
    const sigTextY = signBlockY + (actualImgH > 0 ? actualImgH + 2 : 10);
    doc.setFontSize(8);

    y = Math.max(bankY, sigY) + 5;
    y += 6;

    doc.setTextColor(0);

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory" || "", MARGIN_RIGHT, signBlockY + 14, {
      align: "right",
    });
    // const rowBottomY = Math.max(bankY, currentY + 27, signBlockY + 10);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    //  y = rowBottomY +3 ;
    const rowBottomY = Math.max(bankY, currentY + 27, sigTextY);

    y = rowBottomY + 5; // Only a 4mm gap before Notes

    // REDUCED BUFFER: Only jump to new page if within 1.5cm of bottom
    if (y > pageH - 20) {
      doc.addPage();
      y = PADDING + 5;
    }

    y += 5;

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      // doc.setTextColor(36, 36, 36);
      if (y > pageH - 25) {
        doc.addPage();
        y = PADDING + 5; // Reset to top of new page
      }
      doc.setTextColor(72, 72, 72);
      doc.text("Terms & Conditions", PADDING, y);
      doc.setTextColor(0);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8.5);

      // 1. Split text into lines
      const termLines = doc.splitTextToSize(terms, pageW - 20);

      // 2. Define your custom line height (distance between points)
      const customLineHeight = 5; // Increase this number to get more space between lines

      let currentTermY = y + 5; // Start position for the first line

      // 3. Loop through lines to draw them one by one with extra space
      termLines.forEach((line) => {
        // Check if we need a new page before drawing the line
        if (currentTermY > pageH - 20) {
          doc.addPage();
          currentTermY = 10; // Reset Y for the new page
        }

        doc.text(line, PADDING, currentTermY);
        currentTermY += customLineHeight; // This creates the height/distance you want
      });

      y = currentTermY + 5; // Update leftY for whatever comes next
    }

    // draw table ONLY if rows exist

    if (globalData?.storeSettings?.negobillBranding) {
      // console.log("ghu")
      const y = pageH - 5;
      const rightX = pageW / 2 - 10;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");

      // Start X so whole string is right-aligned
      const startX = rightX;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, y, {
        align: "center",
      });

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + 1 + normalW, y, {
        align: "center",
      });
    }
    setDownload(false);
    return doc;
  };

  const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    // Header Logic
    const PADDING = 5;
    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;
    const COL_RIGHT = pageW - 65;
    const COL_MIDDLE = pageW / 2.8;
    let y = PADDING + 5;
    const invoiceText =
      globalData.status === "CANCELLED" ? "CANCELLED" : "BILL RECIEP";
    const originalText = "ORIGINAL FOR RECIPIENT";
    function drawSpacedText(doc, text, x, y, spacing = 0.8) {
      let cursorX = x;
      for (const ch of text) {
        doc.text(ch, cursorX, y);
        cursorX += doc.getTextWidth(ch) + spacing;
      }
    }
    // --- Row 1: Header Titles ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(14);
    doc.setTextColor(20, 40, 100); // Navy blue for "TAX INVOICE"
    // doc.text(invoiceText, MARGIN_LEFT, y);
    drawSpacedText(doc, invoiceText, MARGIN_LEFT, y, 0.6);

    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90); // Gray
    // doc.text(originalText, MARGIN_RIGHT, y, { align: "right" });
    const textWidth = originalText
      .split("")
      .reduce((w, ch) => w + doc.getTextWidth(ch) + 0.6, 0);

    drawSpacedText(doc, originalText, MARGIN_RIGHT - textWidth, y, 0.6);

    const address = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode
    );

    // --- Row 2: Seller Info & Logo ---
    y = 20;
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(globalData?.salefrom?.title || "", PADDING, y);

    // Placeholder for Logo (Replace with doc.addImage(base64, 'PNG', x, y, w, h))
    doc.setFontSize(22);
    doc.setTextColor(34, 139, 34); // DMart Green
    if (globalData?.salefrom?.image) {
      try {
        const imagePath =
          uRLs?.IMAGE_URL + "profile/" + globalData?.salefrom?.image;

        // const imagePath = settings?.saleProfileData?.image ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png";
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 40;
        const maxHeight = 10;

        let imgW = width;
        let imgH = height;

        const ratio = Math.min(maxWidth / imgW, maxHeight / imgH);

        const finalW = imgW * ratio;
        const finalH = imgH * ratio;

        const ext = imagePath.split(".").pop().toLowerCase();
        const format = ext === "png" ? "PNG" : "JPEG";
        const logoX = MARGIN_RIGHT - finalW;
        // Use finalW and finalH instead of maxWidth and maxHeight
        doc.addImage(base64, format, logoX, y, finalW, finalH);
        // doc.addImage(base64, format, pageW - 60, y - 5, maxWidth, maxHeight);
      } catch (err) {
        console.warn("Logo load failed:", err);
        // Fallback text if logo fails
        doc.setFontSize(22);
        doc.setTextColor(34, 139, 34);
        doc.text("Test-Store", MARGIN_RIGHT, y + 5, { align: "right" });
      }
    }

    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(0);
    // y += 6;
    // doc.text(`GSTIN: ${data?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
    y += 4;
    doc.setFont("Inter-Regular", "normal");
    const addressWidth = pageW / 2 - MARGIN_LEFT - 5;
    const addressLines = doc.splitTextToSize(address, addressWidth);
    doc.text(addressLines, MARGIN_LEFT, y);
    y += addressLines.length * 4;

    doc.text(`Mobile: ${globalData?.salefrom?.phone || ""}`, MARGIN_LEFT, y);
    doc.setFont("Inter-Bold", "bold");
    // Check for PAN
    if (globalData?.salefrom?.pannumber) {
      y += 4;
      doc.text(`PAN: ${globalData.salefrom.pannumber}`, MARGIN_LEFT, y);
    }

    // Check for FSSAI
    if (globalData?.salefrom?.fassi) {
      y += 4;
      doc.text(`FSSAI: ${globalData.salefrom.fassi}`, MARGIN_LEFT, y);
    }

    // Check for CIN
    if (globalData?.salefrom?.cinnumber) {
      y += 4;
      doc.text(`CIN: ${globalData.salefrom.cinnumber}`, MARGIN_LEFT, y);
    }

    doc.setFont("Inter-Regular", "normal");
    // --- Row 3: Invoice Meta Data ---
    // y += 5;
    doc.setDrawColor(200);

    // doc.line(MARGIN_LEFT, y, MARGIN_RIGHT, y);// Thin separator line
    y += 5;
    const invDate = DateConverter.ISOToDisplayFormat(globalData?.saledate).date;
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, timezone)
    ).time;
    y += 4;
    const startYAddress = y;

    doc.setFont("Inter-Bold", "bold");
    // doc.text(`Invoice #: ${ data.saleno || ''}`, 10, y);
    doc.setFontSize(9);
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill #: ", MARGIN_LEFT, y);
    let invNoX = PADDING + doc.getTextWidth("Bill #: ");

    doc.setFontSize(10);
    doc.text(`${globalData.saleno || ""}`, invNoX, y);

    // doc.text(`Invoice Date: ${invDate || ''}`, pageW / 2.8, y);
    doc.setFontSize(9);
    const dateLabel = "Bill Date: ";
    const dateX = pageW / 2.8;
    doc.setFont("Inter-Bold", "bold");
    doc.text(dateLabel, dateX, y);
    let dateValX = dateX + doc.getTextWidth(dateLabel);
    doc.setFontSize(10);
    doc.text(`${invDate || ""}`, dateValX, y);

    doc.setFontSize(9);

    // doc.text(`Due Date: ${invDate || ''}`, pageW - 60, y);
    const rightX = pageW - 65;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Time: ", rightX, y);
    let dueX = rightX + doc.getTextWidth("Bill Time: ");
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(10);
    doc.text(`${invDateTime || ""}`, dueX, y);
    const customerAddress = [
      [
        globalData?.saleto?.addressline1,
        globalData?.saleto?.addressline2,
        globalData?.saleto?.district,
        globalData?.saleto?.state,
        globalData?.saleto?.country,
        globalData?.saleto?.pincode,
      ]
        .filter(Boolean)
        .join(", "),

      // [data?.saleto?.district, data?.saleto?.state, data?.saleto?.pincode].filter(Boolean).join(", ")
    ].join("\n");
    const hasCustomer = !!globalData?.saleto;
    const hasAddress = !!customerAddress;
    const rowStartY = hasCustomer || hasAddress ? y + 5 : y;

    // const rowStartY = y + 5;
    let maxColumnY = rowStartY;

    // Helper to draw Bold Label and Normal Value
    const drawLabelValue = (label, value, x, currentY) => {
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(`${label}: `, x, currentY);
      const labelWidth = doc.getTextWidth(`${label}: `);
      doc.setFont("Inter-Regular", "normal");
      doc.setTextColor(0);
      doc.text(String(value), x + labelWidth, currentY);
    };

    const colWidth = 55; // Same for Billing and Shipping
    const lineStep = 4; // Standard vertical spacing for lines
    let col1X = MARGIN_LEFT;
    let col2X = pageW / 2.8;
    let col3X = pageW - 65;
    if (!hasCustomer) {
      col2X = MARGIN_LEFT;
      col3X = pageW / 2;
    }
    if (hasCustomer && !hasAddress) {
      col2X = pageW / 2;
    }
    /* --- COLUMN 1: Customer Details --- */
    let col1Y = rowStartY;
    doc.setFontSize(9);
    if (hasCustomer) {
      doc.setFont("Inter-Regular", "normal");
      doc.text("Customer Details:", MARGIN_LEFT, col1Y);
      col1Y += 5;

      doc.setFont("Inter-Bold", "bold");
      const customerName = globalData?.saleto?.name || "-";
      const nameLines = doc.splitTextToSize(customerName, colWidth);
      doc.text(nameLines, PADDING, col1Y);
      col1Y += nameLines.length * lineStep;

      doc.setFont("Inter-Regular", "normal");
      doc.text(`Ph: ${globalData?.saleto?.phone || ""}`, MARGIN_LEFT, col1Y);

      // if (data?.saleto?.gstnumber) {
      //   col1Y += 4;
      //   drawLabelValue("GSTIN", data.saleto.gstnumber, 10, col1Y);
      // }
      if (globalData?.saleto?.fassi) {
        col1Y += 4;
        drawLabelValue("FSSAI", globalData.saleto.fassi, MARGIN_LEFT, col1Y);
      }
      if (globalData?.saleto?.pannumber) {
        col1Y += 4;
        drawLabelValue("PAN", globalData.saleto.pannumber, MARGIN_LEFT, col1Y);
      }
      if (globalData?.saleto?.cinnumber) {
        col1Y += 4;
        drawLabelValue("CIN", globalData.saleto.cinnumber, MARGIN_LEFT, col1Y);
      }
    }
    /* --- COLUMN 2: Billing Address --- */
    let col2Y = rowStartY;

    if (hasAddress) {
      doc.setFont("Inter-Regular", "normal");
      doc.text("Billing address:", col2X, col2Y);
      col2Y += 5;

      const billLines = doc.splitTextToSize(customerAddress || "-", colWidth);
      doc.text(billLines, col2X, col2Y);
      col2Y += billLines.length * lineStep; // Actual dynamic height
    }
    /* --- COLUMN 3: Shipping Address --- */
    let col3Y = rowStartY;
    if (hasAddress) {
      const col3X = pageW - 65; // Slightly adjusted for margin
      doc.setFont("Inter-Regular", "normal");
      doc.text("Shipping address:", col3X, col3Y);
      col3Y += 5;

      const shipLines = doc.splitTextToSize(customerAddress || "-", colWidth);
      doc.text(shipLines, col3X, col3Y);
      col3Y += shipLines.length * lineStep; // Actual dynamic height
    }
    maxColumnY = Math.max(
      hasCustomer ? col1Y : rowStartY,
      hasAddress ? col2Y : rowStartY,
      hasAddress ? col3Y : rowStartY
    );
    /* --- PLACE OF SUPPLY --- */

    y = maxColumnY + 5;
    if (
      globalData?.saleto?.state
    ) {
      doc.setFontSize(10);
      doc.setFont("Inter-Regular", "normal");
      doc.text("Place Of Supply: ", MARGIN_LEFT, y);
      const supplyWidth = doc.getTextWidth("Place Of Supply: ");
      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(36, 36, 36);
      doc.text(globalData?.saleto?.state || "-", MARGIN_LEFT + supplyWidth, y);
      // Final safety margin before table
      y += 4;
    }
    const leftBoxX = 8;

    /* -------------------------------------------------
         PRODUCT TABLE
      ------------------------------------------------- */
    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { left: MARGIN_LEFT, right: MARGIN_LEFT }, // Balanced margins for symmetry
      // tableWidth: 'auto',
      styles: {
        font: "Inter-Regular",
        fontSize: 9,
        cellPadding: 2, // Extra vertical padding for clarity
        valign: "middle",
        lineHeight: 1.5,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        textColor: [0, 0, 0], // True black text
      },
      headStyles: {
        font: "Inter-Bold",
        fontSize: 9,
        // textColor: [0, 0, 0],
        // fillColor: false,
        fillColor: selectedTheme?.templateTheme?.primaryColor || [20, 40, 100], // Navy blue fill
        textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
        lineWidth: { top: 0.1, bottom: 0.1 },
        lineColor: selectedTheme?.templateTheme?.borderColor,
      },
      head: [["#", "Item", "MRP", "Selling Price", "Qty", "Amount"]],
      body: globalData?.saleitems.map((it, i) => {
        // Exact Item + HSN formatting like image_f6047a.png
        const itemDesc = it.hsnsac
          ? `${it.title}\n${it.imode === "SERVICE" ? "SAC" : "HSN"}: ${
              it.hsnsac
            }`
          : it.title;
        const amount = it.lineGrandTotal;
        const mrp = it.mrp;
        const baseprice = it.baseprice;
        return [
          i + 1,
          itemDesc,
          `₹${mrp}`,
          `₹${baseprice}`,
          `${it.quantity} `, //Pcs
          `₹${amount}`,
        ];
      }),
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // S.No
        1: { cellWidth: "auto", halign: "left" }, // Flexible Description
        2: { cellWidth: 35, halign: "right" }, // Right-aligned Price
        3: { cellWidth: 30, halign: "right" },
        4: { cellWidth: 20, halign: "right" }, // Right-aligned Price
        5: { cellWidth: 25, halign: "right" }, // Amount
      },
      didParseCell: function (data) {
        // Header alignment
        if (data.section === "head") {
          const colId = data.column.index;
          if (colId === 0) data.cell.styles.halign = "center";
          if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
            data.cell.styles.halign = "right";
        }

        if (data.section === "body") {
          data.cell.styles.lineWidth = { bottom: 0.1 };
        }
      },
    });

    y += 3;

    const igst = globalData.igstamount;
    const sgst = globalData.sgstamount;
    const cgst = globalData.cgstamount;
    const linetotalbaseprice = globalData.totalbaseprice;
    const grantotal = globalData.grandtotal;
    const paidamount = globalData.paidamount;

    /* -------------------------------------------------
       TOTALS & GST SECTION (Right Side)
    ------------------------------------------------- */
    y = doc.lastAutoTable.finalY + 5; // Start after the table

    // 1. Grand Total Row
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(12);

    const totalTextX = 140;
    const totalValueX = 200; // This is your right-aligned anchor

    doc.text("Total", totalTextX, y);
    doc.text(`₹${grantotal}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    // FIX: The line must end exactly at 200 to match your text alignment
    y += 2;
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    doc.setLineWidth(0.1);
    doc.line(totalTextX, y, MARGIN_RIGHT, y); // Line now matches text width perfectly
    // 2. Tax Breakdown
    y += 6;
    // doc.setFont("Inter-Regular", "normal");
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    // doc.setTextColor(0);
    doc.setTextColor(48, 48, 48); // #303030

    // const summaryData = [
    //   ["Total Amount Before Tax", `₹${formatCurrencyINR(linetotalbaseprice)}`],
    //   ["CGST ", `₹${formatCurrencyINR(cgst)}`],
    //   ["SGST ", `₹${formatCurrencyINR(sgst)}`],
    // ];

    // summaryData.forEach(([label, value]) => {
    //   doc.text(label, 140, y);
    //   doc.text(value, MARGIN_RIGHT, y, { align: "right" });
    //   y += 5;
    // });
    doc.setTextColor(64, 64, 64);

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);

    doc.text(`Total Items  : ${globalData?.totalItems || 0} `, PADDING, y);
    doc.setTextColor(0);
    const amountWords = globalData?.amountinwords || "";
    doc.text(`Total amount (in words): INR ${amountWords}`, MARGIN_RIGHT, y, {
      align: "right",
    });

    y += 2;

    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    doc.setLineWidth(0.1);
    doc.line(PADDING, y, MARGIN_RIGHT, y);

    y += 5;

    doc.setTextColor(0);
    const footerStartY = y;
    doc.setFontSize(9);

    doc.setFont("Inter-Bold", "bold");
    doc.setTextColor(32, 32, 32);
    y = footerStartY;
    const balanceDue = grantotal - paidamount;
    const payX = 140;
    const payments = [
      ["Amount Payable:", `₹${globalData?.balanceDue}`],
      ["Amount Paid:", `₹${paidamount}`],
    ];

    payments.forEach(([label, value]) => {
      doc.setFont("Inter-Bold", "bold");
      doc.text(label, payX, y);
      doc.text(value, MARGIN_RIGHT, y, { align: "right" });
      y += 4;
    });

    const paymentRows = [];
    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);
    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");
    let neededFooterHeight = 0;
    if (cashAmt > 0) neededFooterHeight += 4;
    if (upiAmt > 0) neededFooterHeight += 4;
    if (cardAmt > 0) neededFooterHeight += 4;
    if (onlineAmt > 0) neededFooterHeight += 4;

    neededFooterHeight += 35;
    if (y + neededFooterHeight > pageH - 20) {
      doc.addPage();
      y = 10;
    }
    doc.setFontSize(8);
    y += 2;
    doc.setFont("Inter-Bold", "bold");
    if (globalData?.cashPaid > 0) {
      const cashText = `₹${globalData?.cashPaid} Paid via Cash `;
      doc.text(cashText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.upiPaid > 0) {
      y += 4;
      const upiText = `₹${globalData?.upiPaid} Paid via UPI `;
      doc.text(upiText, MARGIN_RIGHT, y, { align: "right" });
    }

    if (globalData?.cardPaid > 0) {
      y += 4;
      const cardText = `₹${globalData?.cardPaid} Paid via Card `;
      doc.text(cardText, MARGIN_RIGHT, y, { align: "right" });
    } //on ${invDate}`

    if (globalData?.onlinePaid > 0) {
      y += 4;
      const onlineText = `₹${globalData?.onlinePaid} Paid Online `;
      doc.text(onlineText, MARGIN_RIGHT, y, { align: "right" });
    }

    y += 10;
    const footerBlockHeight = 25;
    const spaceRemaining = pageH - y;

    // If remaining space is less than the footer height, jump to a new page
    if (spaceRemaining < footerBlockHeight) {
      doc.addPage();
      y = 10;
    }
    const currentY = y;

    const paymentSettings = globalData?.storeSettings?.paymentSettings;

    const upiId = paymentSettings?.upiId || "";
    const payeeName = paymentSettings?.bankDetails?.beneficiaryName || "";
    const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(
      payeeName
    )}&cu=INR`;
    const hasUpi = upiId && upiId.trim().length > 0;
    const bankX = hasUpi ? 45 : PADDING;
    // console.log("bankX", bankX);
    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");

    if (upiId && upiId.trim() !== "") {
      let footerY = y;
      doc.text("Pay using UPI:", PADDING - 2, footerY);
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      const qrX = PADDING - 2;
      const qrY = footerY + 2;
      const qrSize = 25;
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, qrY, qrSize, qrSize);
    }

    doc.setFontSize(10);
    doc.setTextColor(56, 56, 56);
    doc.setFont("Inter-Bold", "bold");
    let bankY = currentY + 5;
    if (paymentSettings?.bankDetails) {
      doc.text("Bank Details:", bankX, currentY);

      const bankDetails = [
        ["Bank:", paymentSettings?.bankDetails?.ifscbankName || ""],
        ["Account #:", paymentSettings?.bankDetails?.accountNo || ""],
        ["IFSC:", paymentSettings?.bankDetails?.ifsc || ""],
        ["Branch:", paymentSettings?.bankDetails?.branch || ""],
      ];

      bankDetails.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, bankX, bankY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value), bankX + 20, bankY);
        bankY += 5;
      });
    }

    let sigY = currentY;
    const rightX1 = 202;

    doc.setFontSize(6);
    let actualImgH = 0;
    let signBlockY = sigY;
    if (globalData?.storeSettings?.invoiceSettings?.signature) {
      try {
        const signimg =
          uRLs.IMAGE_URL + globalData?.storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 35;
        const maxHeight = 20;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(
          base64,
          signimg.endsWith(".png") ? "PNG" : "JPEG",
          MARGIN_RIGHT - imgW + 3,
          signBlockY,
          imgW,
          imgH
        );
      } catch {
        console.warn("Signature load failed");
      }
    }
    // sigY += 25;
    const sigTextY = signBlockY + (actualImgH > 0 ? actualImgH + 2 : 10);
    doc.setFontSize(8);

    y = Math.max(bankY, sigY) + 5;
    y += 6;

    doc.setTextColor(0);

    doc.setFont("Inter-Regular", "normal");
    doc.text("Authorized Signatory" || "", MARGIN_RIGHT, signBlockY + 14, {
      align: "right",
    });
    // const rowBottomY = Math.max(bankY, currentY + 27, signBlockY + 10);
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(9);
    //  y = rowBottomY +3 ;
    const rowBottomY = Math.max(bankY, currentY + 27, sigTextY);

    y = rowBottomY + 5; // Only a 4mm gap before Notes

    // REDUCED BUFFER: Only jump to new page if within 1.5cm of bottom
    if (y > pageH - 20) {
      doc.addPage();
      y = 10;
    }

    y += 5;

    if (terms?.length > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      // doc.setTextColor(36, 36, 36);
      if (y > pageH - 25) {
        doc.addPage();
        y = PADDING + 5; // Reset to top of new page
      }
      doc.setTextColor(72, 72, 72);
      doc.text("Terms & Conditions", PADDING, y);
      doc.setTextColor(0);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8.5);

      // 1. Split text into lines
      const termLines = doc.splitTextToSize(terms, pageW - 20);

      // 2. Define your custom line height (distance between points)
      const customLineHeight = 5; // Increase this number to get more space between lines

      let currentTermY = y + 5; // Start position for the first line

      // 3. Loop through lines to draw them one by one with extra space
      termLines.forEach((line) => {
        // Check if we need a new page before drawing the line
        if (currentTermY > pageH - 20) {
          doc.addPage();
          currentTermY = 10; // Reset Y for the new page
        }

        doc.text(line, PADDING, currentTermY);
        currentTermY += customLineHeight; // This creates the height/distance you want
      });

      y = currentTermY + 5; // Update leftY for whatever comes next
    }

    // draw table ONLY if rows exist

    if (globalData?.storeSettings?.negobillBranding) {
      const y = pageH - 5;
      const rightX = pageW / 2 - 10;

      // Text parts
      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFontSize(8);

      // Measure widths
      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");

      // Start X so whole string is right-aligned
      const startX = rightX;

      // Draw normal part
      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, y, {
        align: "center",
      });

      // Draw bold part
      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + 1 + normalW, y, {
        align: "center",
      });
    }
    setDownload(false);
    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBill1();
    } else {
      doc = await generateInvoice1();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    if (data?.saleno) {
      handleDownload(data);
    }
  }, [data?.saleno]);
 useEffect(() => {
    const upi = globalData?.storeSettings?.paymentSettings?.upiId;

    const name = globalData?.storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    globalData?.storeSettings?.paymentSettings?.upiId,
    globalData?.storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);
  useEffect(() => {
    setData(isData);
  }, [isData]);

   const isBillReceipt =
    globalData?.salemode?.toUpperCase() === "BILL" &&
    globalData?.storeSettings?.saleSettings?.saleModeSettings?.isTaxInfo;

  const documentTitle = isBillReceipt
    ? "BILL RECEIPT"
    : "TAX INVOICE";
  const invLabel = isBillReceipt ? "Bill #:" : "Invoice #:";
  const invDates = isBillReceipt ? "Bill Date:" : "Invoice Date:";
  const invTimes = isBillReceipt ? "Bill Time:" : "Invoice Time:";
  const actualPaidAmount = globalData?.grandtotal - globalData?.balanceDue;
  
  return ( <>
         
             <InvoiceLayout>
                      {globalData?.salemode === "INVOICE" || isBillReceipt? (
                        <>                          
                            <InvoiceWrapper>
                                  <div className="tm_invoice_in p-2">
                                    <div className="d-flex justify-content-between mb-3">
                                      <div
                                        className="tm_text_uppercase"
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "600",
                                        }}
                                      >
                                      
                                        {documentTitle}
                                      </div>
                                      <div>ORIGINAL FOR RECIPIENT</div>
                                    </div>
                                    <div className="row">
                                      <div className="col-7 pe-1 ">
                                        <div className="d-flex gap-2 align-items-start">
                                          
                                          <div>
                                            <div
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                marginBottom: "5px",
                                              }}
                                            >
                                              {globalData.salefrom?.title || ""}
                                            </div>
                                            {globalData?.salefrom
                                              ?.gstnumber && (
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "600",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <>GSTIN:</>{" "}
                                                {globalData?.salefrom
                                                  ?.gstnumber || ""}
                                              </div>
                                            )}
                                            <div>
                                              {globalData?.salefrom
                                                ?.addressline1 || ""}{" "}
                                              {globalData?.salefrom
                                                ?.addressline2 || ""}{" "}
                                            </div>
                                            <div>
                                              {globalData?.salefrom?.district ||
                                                ""}
                                              {", "}
                                              {globalData?.salefrom?.state ||
                                                ""}
                                              {", "}
                                              {globalData?.salefrom?.pincode ||
                                                ""}
                                            </div>
                                            {/* <div>
                                        CIN :{data?.salefrom?.cinnumber}
                                      </div> */}
                                            {/* {data?.salefrom?.pannumber && (
                                        <div>
                                          <strong>PAN:</strong>{" "}
                                          {data?.salefrom?.pannumber || ""}
                                        </div>
                                      )} */}
                                            <div>
                                              {" "}
                                              Mobile:{" "}
                                              {globalData?.salefrom?.phone ||
                                                ""}
                                            </div>
                                            {/* {data?.salefrom?.gstnumber && (
                                        <div>
                                          <strong>GSTIN:</strong>{" "}
                                          {data?.salefrom?.gstnumber || ""}
                                        </div>
                                      )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-5 ps-1 ">
                                        <div className="tm_logo text-end">
                                          {globalData?.salefrom?.image && (
                                            <img
                                              src={
                                                uRLs.IMAGE_URL +
                                                "profile/" +
                                                globalData?.salefrom?.image
                                              }
                                              className="img-rounded logo mb-0"
                                              height="45"
                                              width="100"
                                              style={{ objectFit: "contain" }}
                                            />
                                          )}
                                        </div>
                                        {/* <div className="border h-100 p-2">
                                  <div className="tm_text_uppercase text-end">
                                    {data.salemode &&
                                      formatTrackMode(data.salemode)}
                                  </div>
                                  <div>
                                    <b>Invoice #</b> : {data.saleno}
                                  </div>
                                  <div>
                                    <b>Date</b> : {saleTime.date}
                                  </div>
                                  <div>
                                    <b>Place Of Supply</b> :{" "}
                                    {data?.salefrom?.state || ""}
                                  </div>
                                  <div>
                                    <b>Due Date</b> : {saleTime.date}
                                  </div>
                                  <div>
                                    <b>Sales Person</b> : -
                                  </div>
                                </div> */}
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col-12  col-md-4 pe-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                              {invLabel}
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {globalData?.saleno}
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&
                                            (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Customer Details
                                                </div>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    marginBottom: "0px",
                                                  }}
                                                >
                                                  <strong>
                                                    {globalData?.saleto?.name ||
                                                      ""}
                                                  </strong>
                                                </div>
                                                <div>
                                                  {" "}
                                                  ph:{" "}
                                                  {globalData?.saleto?.phone ||
                                                    ""}
                                                </div>
                                                {globalData?.saleto
                                                  ?.gstnumber && (
                                                  <div>
                                                    <strong>GSTIN:</strong>{" "}
                                                    {globalData?.saleto
                                                      ?.gstnumber || ""}
                                                  </div>
                                                )}
                                                {globalData.saleto
                                                  ?.pannumber && (
                                                  <div>
                                                    <strong>PAN:</strong>{" "}
                                                    {globalData.saleto
                                                      ?.pannumber || ""}
                                                  </div>
                                                )}
                                                {globalData.saleto
                                                  ?.cinnumber && (
                                                  <div>
                                                    <strong>CIN :</strong>
                                                    {globalData?.saleto
                                                      ?.cinnumber || ""}
                                                  </div>
                                                )}
                                                {globalData.saleto?.state && (
                                                  <div className="my-2 font-14">
                                                    Place Of Supply :
                                                    <strong>
                                                      {globalData.saleto
                                                        ?.state || ""}{" "}
                                                    </strong>
                                                  </div>
                                                )}{" "}
                                              </>
                                            )}
                                        </div>
                                      </div>
                                      <div className="col-12 col-md-4 ps-md-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                             {invDates}
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {saleTime.date}
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&
                                         (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Billing Address
                                                </div>

                                                <div>
                                                  {globalData?.saleto
                                                    ?.addressline1 || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.addressline2 || ""}{" "}
                                                </div>
                                                <div>
                                                  {globalData?.saleto?.state ||
                                                    ""}{" "}
                                                  {globalData?.saleto
                                                    ?.district || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.country || ""}{" "}
                                                  -{" "}
                                                  {globalData?.saleto
                                                    ?.pincode || ""}
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                      <div className="col-12 col-md-4 ps-md-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                             {invTimes}
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {
                                                DateConverter.ISOToDisplayFormat(
                                                  DateConverter.convertToTimeZone(
                                                    globalData?.saledate,
                                                   timezone,
                                                  ),
                                                ).time
                                              }
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&                                            
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline1 &&
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline2 && (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Shipping Address
                                                </div>
                                                {/* <div
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {data.saleto?.name || ""}
                                    </div> */}
                                                <div>
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline1 || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline2 || ""}{" "}
                                                </div>
                                                <div>
                                                  {globalData?.saleto
                                                    ?.shippingAddress?.state ||
                                                    ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.district || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.country || ""}{" "}
                                                  -{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.pincode || ""}
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: "100%",
                                        overflowX: "auto",
                                        WebkitOverflowScrolling: "touch",
                                      }}
                                    >
                                    <table
                                      // className="items"
                                      width="100%"
                                      style={{
                                        marginTop: "6px",
                                        borderCollapse: "collapse",
                                        borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        // borderBottom: "1px solid #000"
                                      }}
                                      cellPadding="4"
                                    >
                                      <thead>
                                        <tr
                                          style={{
                                            borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                          }}
                                        >
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "20px",
                                              textAlign: "center",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            #
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              // width: "240px",
                                              textAlign: "left",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Item
                                          </th>

                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "50px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            MRP
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              //     ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Selling Price
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Qty
                                          </th>

                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {globalData?.saleitems?.map(
                                          (product, index) => (
                                            <tr
                                              key={index}
                                              style={{
                                                borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                              }}
                                            >
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "left",
                                                  fontSize: "12px",
                                                  width: "53%",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                <div>{product.title}</div>
                                                {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )} */}
                                                {/* {product.imode === "PRODUCT" &&
                                        product.note && (
                                          <div className="ms-0 fsz-10 mb-1">
                                            {product?.note}
                                          </div>
                                        )} */}
                                                {product.hsnsac && (
                                                  <div>
                                                    <span className="fw-medium">
                                                      {" "}
                                                      {product.imode ===
                                                      "SERVICE"
                                                        ? "SAC:"
                                                        : "HSN:"}
                                                    </span>{" "}
                                                    {product.hsnsac}
                                                  </div>
                                                )}
                                                {/* {product.discount > 0 && (
                                      <>
                                        <div>
                                          <span className="fw-medium">MRP : </span> ₹
                                          {CurrencyConverter.toCurrency(
                                            product.mrp || 0,
                                            "INR"
                                          )}
                                        </div>
                                        <div>
                                          <span className="fw-medium">Discount : </span> -
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            product.discount || 0,
                                            "INR"
                                          )}
                                        </div>
                                      </>
                                    )} */}
                                              </td>
                                              {/* <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {product.hsnsac}
                                    </td> */}
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product?.mrp}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product?.baseprice}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                {product?.quantity}
                                                <span className="font-11 ms-1">
                                                  {(() => {
                                                    const unitCode =
                                                      product?.isSecondaryUnit
                                                        ? product?.unitConfig
                                                            ?.secondaryUnitCode
                                                        : product?.unitConfig
                                                            ?.primaryUnitCode;

                                                    // return unitCode !== "unit" ? unitCode : "";
                                                    return unitCode || "";
                                                  })()}
                                                </span>
                                              </td>
                                       

                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product.lineGrandTotal}
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td
                                            colSpan="2"
                                            style={{
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: 600,
                                                textAlign: "start",
                                              }}
                                            >
                                              Total
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "end",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            ₹{globalData?.grandtotal}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td colSpan="2" className="text-end">
                                            Total Amount Before Tax{" "}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "end",
                                              fontSize: "12px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            ₹{globalData?.totalbaseprice}{" "}
                                          </td>
                                        </tr>
                                        {globalData?.salefrom?.statecode &&
                                        globalData?.saleto?.statecode &&
                                        globalData?.salefrom?.statecode !==
                                          globalData?.saleto?.statecode ? (
                                          <tr>
                                            <td colSpan="3"></td>
                                            <td
                                              colSpan="2"
                                              className="text-end"
                                            >
                                              IGST
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "end",
                                                fontSize: "12px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              ₹{globalData?.igstamount}{" "}
                                            </td>
                                          </tr>
                                        ) : (
                                          <>
                                            <tr>
                                              <td colSpan="3"></td>
                                              <td
                                                colSpan="2"
                                                className="text-end"
                                              >
                                                CGST
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "end",
                                                  fontSize: "12px",
                                                  fontWeight: 600,
                                                  padding: "2px 4px",
                                                }}
                                              >
                                                ₹{globalData?.cgstamount}{" "}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colSpan="2"></td>
                                              <td
                                                colSpan="3"
                                                className="text-end"
                                              >
                                                SGST
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "end",
                                                  fontSize: "12px",
                                                  fontWeight: 600,
                                                  padding: "2px 4px",
                                                }}
                                              >
                                                ₹{globalData?.sgstamount}{" "}
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                        <tr
                                          style={{
                                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                          }}
                                        >
                                          <td
                                            colSpan={2}
                                            style={{ width: "30%" }}
                                          >
                                            Total Items :{" "}
                                            {globalData?.saleitems?.length}
                                          </td>

                                          <td
                                            colSpan={4}
                                            style={{
                                              textAlign: "end",
                                              fontSize: "12px",
                                              fontWeight: 500,
                                              marginBottom: "0",
                                            }}
                                          >
                                            Total Amount (in Words)
                                            {globalData.amountinwords}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td
                                            colSpan="2"
                                            className="text-end fw-bold"
                                          >
                                            Amount Payable
                                          </td>
                                          <td className="fw-bold text-end font-12 fw-600 mb-0">
                                            ₹{globalData?.balanceDue}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td colSpan="2" className="text-end">
                                            Amount Paid
                                          </td>
                                          <td className="text-end font-12">
                                            ₹
                                            {parseFloat(
                                              actualPaidAmount || 0,
                                            ).toFixed(2)}{" "}
                                          </td>
                                        </tr>
                                        {globalData?.cashPaid > 0 && (
                                          <tr>
                                            <td colSpan="2"></td>
                                            <td
                                              colSpan={4}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.cashPaid}</b>{" "}
                                              Paid Via Cash
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.upiPaid > 0 && (
                                          <tr>
                                            <td colSpan="2"></td>
                                            <td
                                              colSpan={4}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.upiPaid}</b> Paid
                                              Via UPI
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.cardPaid > 0 && (
                                          <tr>
                                            <td colSpan="2"></td>
                                            <td
                                              colSpan={4}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.cardPaid} </b>
                                              Paid Via Card
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.onlinePaid > 0 && (
                                          <tr>
                                            <td colSpan="2"></td>
                                            <td
                                              colSpan={4}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b> ₹{globalData?.onlinePaid}</b>{" "}
                                              Paid Via Online
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                    </div>
                                    <div className="row mt-4 align-items-start">
                                      {/* 🔹 LEFT: QR Code */}
                                      <div className="col-6 col-md-2 px-0">
                                        <div className="d-flex flex-column  align-items-md-start">
                                        <span className="px-2 fw-bold pb-0">
                                          Pay Using UPI
                                        </span>
                                        {globalData?.storeSettings?.paymentSettings
                                          ?.upiId && (
                                          <img
                                            src={qrCodeDataUrl}
                                            alt="QR Code"
                                            style={{
                                              width: "90px",
                                              height: "90px",
                                            }}
                                          />
                                        )}
                                        </div>
                                      </div>

                                      {/* 🔹 CENTER: Bank Details */}
                                      <div className="col-6 col-md-6 px-0">
                                        <div className="font-12">
                                          <strong>Bank Details:</strong>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              Name:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails
                                                ?.beneficiaryName || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              Account #:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails?.accountNo || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              IFSC:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails?.ifsc || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              UPI ID:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.upiId || ""}
                                            </strong>
                                          </div>
                                        </div>
                                      </div>

                                      {/* 🔹 RIGHT: Signature */}
                                      <div className="col-12 col-md-4 text-end">
                                        {globalData?.storeSettings?.invoiceSettings
                                          ?.signature && (
                                          <img
                                            src={
                                              uRLs.IMAGE_URL +
                                              globalData?.storeSettings?.invoiceSettings
                                                ?.signature
                                            }
                                            alt="Signature"
                                            style={{
                                              width: "120px",
                                              marginBottom: "5px",
                                            }}
                                          />
                                        )}

                                        <div style={{ fontSize: "12px" }}>
                                          Issued By, Signature
                                        </div>
                                      </div>
                                    </div>
                                    {terms?.length > 0 && (
                                      <table width="100%" className="mt-2">
                                        <tbody>
                                          <tr>
                                            <td width="100%">
                                              <div className="font-12 text-black text-start fw-600">
                                                Terms & Conditions
                                              </div>
                                              <div className="terms-box font-11">
                                                {terms}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    )}
                                    {globalData?.storeSettings?.negobillBranding && (
                                      <div className="d-flex justify-content-center">
                                        {" "}
                                        <span>
                                          Powered by{" "}
                                          <strong>NegoBill.com</strong>
                                        </span>
                                      </div>
                                    )}

                               
                                  </div>
                               </InvoiceWrapper>
                         
                        </>
                      ) : globalData?.salemode === "BILL" ? (
                        <>
                         
                            <InvoiceWrapper>
                                  <div className="tm_invoice_in p-2">
                                    <div className="d-flex justify-content-between mb-3">
                                      <div
                                        className="tm_text_uppercase"
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {globalData?.salemode &&
                                          formatTrackMode(globalData?.salemode)}
                                      </div>
                                      <div>ORIGINAL FOR RECIPIENT</div>
                                    </div>
                                    <div className="row">
                                      <div className="col-7 pe-1 ">
                                        <div className="d-flex gap-2 align-items-start">
                                       
                                          <div>
                                            <div
                                              style={{
                                                fontSize: "17px",
                                                fontWeight: "600",
                                                marginBottom: "5px",
                                              }}
                                            >
                                              {globalData?.salefrom?.title ||
                                                ""}
                                            </div>
                                           
                                            <div>
                                              {globalData?.salefrom
                                                ?.addressline1 || ""}{" "}
                                              {globalData?.salefrom
                                                ?.addressline2 || ""}{" "}
                                            </div>
                                            <div>
                                              {globalData?.salefrom?.district ||
                                                ""}
                                              {", "}
                                              {globalData?.salefrom?.state ||
                                                ""}
                                              {", "}
                                              {globalData?.salefrom?.pincode ||
                                                ""}
                                            </div>
                                            {/* <div>
                                        CIN :{data?.salefrom?.cinnumber}
                                      </div> */}
                                            {/* {data?.salefrom?.pannumber && (
                                        <div>
                                          <strong>PAN:</strong>{" "}
                                          {data?.salefrom?.pannumber || ""}
                                        </div>
                                      )} */}
                                            <div>
                                              {" "}
                                              Mobile:{" "}
                                              {globalData?.salefrom?.phone ||
                                                ""}
                                            </div>
                                            {/* {data?.salefrom?.gstnumber && (
                                        <div>
                                          <strong>GSTIN:</strong>{" "}
                                          {data?.salefrom?.gstnumber || ""}
                                        </div>
                                      )} */}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-5 ps-1 ">
                                        <div className="tm_logo text-end">
                                          {globalData?.salefrom?.image && (
                                            <img
                                              src={
                                                uRLs.IMAGE_URL +
                                                "profile/" +
                                                globalData?.salefrom?.image
                                              }
                                              className="img-rounded logo mb-0"
                                              height="45"
                                              width="100"
                                              style={{ objectFit: "contain" }}
                                            />
                                          )}
                                        </div>
                                     
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col-12  col-md-4 pe-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                              Bill #:
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {globalData?.saleno}
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&
                                             (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Customer Details
                                                </div>

                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    marginBottom: "0px",
                                                  }}
                                                >
                                                  <strong>
                                                    {globalData?.saleto?.name ||
                                                      ""}
                                                  </strong>
                                                </div>

                                                <div>
                                                  {" "}
                                                  ph:{" "}
                                                  {globalData?.saleto?.phone ||
                                                    ""}
                                                </div>
                                                {globalData.saleto
                                                  ?.pannumber && (
                                                  <div>
                                                    <strong>PAN:</strong>{" "}
                                                    {globalData.saleto
                                                      ?.pannumber || ""}
                                                  </div>
                                                )}
                                                {globalData.saleto
                                                  ?.cinnumber && (
                                                  <div>
                                                    <strong>CIN :</strong>
                                                    {globalData?.saleto
                                                      ?.cinnumber || ""}
                                                  </div>
                                                )}
                                                {globalData.saleto?.state && (
                                                  <div className="my-2 font-14">
                                                    Place Of Supply :
                                                    <strong>
                                                      {globalData.saleto
                                                        ?.state || ""}{" "}
                                                    </strong>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                        </div>
                                      </div>
                                      <div className="col-12 col-md-4 ps-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                              Bill Date :
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {saleTime.date}
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&
                                            (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Billing Address
                                                </div>

                                                <div>
                                                  {globalData?.saleto
                                                    ?.addressline1 || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.addressline2 || ""}{" "}
                                                </div>
                                                <div>
                                                  {globalData?.saleto?.state ||
                                                    ""}{" "}
                                                  {globalData?.saleto
                                                    ?.district || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.country || ""}{" "}
                                                  -{" "}
                                                  {globalData?.saleto
                                                    ?.pincode || ""}
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>

                                      <div className="col-12 col-md-4 ps-1">
                                        <div>
                                          <div
                                            style={{
                                              marginBottom: "4px",
                                            }}
                                          >
                                            <span style={{ fontWeight: "600" }}>
                                              Bill Time:
                                            </span>
                                            {""}
                                            <strong className="font-14">
                                              {
                                                DateConverter.ISOToDisplayFormat(
                                                  DateConverter.convertToTimeZone(
                                                    globalData?.saledate,
                                                    timezone,
                                                  ),
                                                ).time
                                              }
                                            </strong>
                                          </div>
                                          {globalData?.saleto &&
                                            
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline1 &&
                                            globalData?.saleto?.shippingAddress
                                              ?.addressline2 && (
                                              <>
                                                <div
                                                  style={{
                                                    fontSize: "12px",
                                                    // fontWeight: "600",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  Shipping Address
                                                </div>
                                            
                                                <div>
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline1 || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.addressline2 || ""}{" "}
                                                </div>
                                                <div>
                                                  {globalData?.saleto
                                                    ?.shippingAddress?.state ||
                                                    ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.district || ""}{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.country || ""}{" "}
                                                  -{" "}
                                                  {globalData?.saleto
                                                    ?.shippingAddress
                                                    ?.pincode || ""}
                                                </div>
                                              </>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                     <div
                                      style={{
                                        width: "100%",
                                        overflowX: "auto",
                                        WebkitOverflowScrolling: "touch",
                                      }}
                                    >
                                    <table
                                      // className="items"
                                      width="100%"
                                      style={{
                                        marginTop: "6px",
                                        borderCollapse: "collapse",
                                        borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        // borderBottom: "1px solid #000"
                                      }}
                                      cellPadding="4"
                                    >
                                      <thead>
                                        <tr
                                          className="p-2"
                                          style={{
                                            borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                          }}
                                        >
                                          <th
                                            className="force-style p-1 px-2 "
                                            style={{
                                              width: "20px",
                                              textAlign: "center",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            #
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              // width: "240px",
                                              textAlign: "left",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Item
                                          </th>

                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "50px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            MRP
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              //     ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Selling Price
                                          </th>
                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Qty
                                          </th>

                                          <th
                                            className="force-style p-1 px-2"
                                            style={{
                                              width: "100px",
                                              textAlign: "right",
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {globalData?.saleitems?.map(
                                          (product, index) => (
                                            <tr
                                              key={index}
                                              style={{
                                                borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                              }}
                                            >
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "left",
                                                  fontSize: "12px",
                                                  width: "53%",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                <div>{product.title}</div>
                                           
                                                {product.hsnsac && (
                                                  <div>
                                                    <span className="fw-medium">
                                                      {" "}
                                                      {product.imode ===
                                                      "SERVICE"
                                                        ? "SAC:"
                                                        : "HSN:"}
                                                    </span>{" "}
                                                    {product.hsnsac}
                                                  </div>
                                                )}
                                       
                                              </td>
                                          
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product?.mrp}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product?.baseprice}
                                              </td>
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                {product?.quantity}
                                                <span className="font-11 ms-1">
                                                  {(() => {
                                                    const unitCode =
                                                      product?.isSecondaryUnit
                                                        ? product?.unitConfig
                                                            ?.secondaryUnitCode
                                                        : product?.unitConfig
                                                            ?.primaryUnitCode;

                                                    // return unitCode !== "unit" ? unitCode : "";
                                                    return unitCode || "";
                                                  })()}
                                                </span>
                                              </td>
                                            
                                              <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "right",
                                                  fontSize: "12px",
                                                  // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                }}
                                              >
                                                ₹{product.lineGrandTotal}
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td
                                            colSpan="2"
                                            style={{
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "15px",
                                                fontWeight: 600,
                                                textAlign: "start",
                                              }}
                                            >
                                              Total
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "end",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            ₹{globalData?.grandtotal}{" "}
                                          </td>
                                        </tr>

                                        <tr
                                          style={{
                                            borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                          }}
                                        >
                                          <td
                                            colSpan={2}
                                            style={{ width: "30%" }}
                                          >
                                            Total Items :{" "}
                                            {globalData?.saleitems?.length}
                                          </td>

                                          <td
                                            colSpan={4}
                                            style={{
                                              textAlign: "end",
                                              fontSize: "12px",
                                              fontWeight: 500,
                                              marginBottom: "0",
                                            }}
                                          >
                                            Total Amount (In Words):
                                            {globalData.amountinwords}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td
                                            colSpan="2"
                                            className="text-end  fw-bold"
                                          >
                                            Amount Payable
                                          </td>
                                          <td className="fw-bold text-end font-12 fw-600 mb-0">
                                            ₹{globalData?.balanceDue}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3"></td>
                                          <td colSpan="2" className="text-end">
                                            Amount Paid
                                          </td>
                                          <td className="text-end font-12">
                                            ₹
                                            {parseFloat(
                                              actualPaidAmount || 0,
                                            ).toFixed(2)}{" "}
                                          </td>
                                        </tr>
                                        {globalData?.cashPaid > 0 && (
                                          <tr>
                                            <td colSpan="3"></td>
                                            <td
                                              colSpan={3}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.cashPaid}</b>{" "}
                                              Paid Via Cash
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.upiPaid > 0 && (
                                          <tr>
                                            <td colSpan="3"></td>
                                            <td
                                              colSpan={3}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.upiPaid}</b> Paid
                                              Via UPI
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.cardPaid > 0 && (
                                          <tr>
                                            <td colSpan="3"></td>
                                            <td
                                              colSpan={3}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b>₹{globalData?.cardPaid} </b>
                                              Paid Via Card
                                            </td>
                                          </tr>
                                        )}
                                        {globalData?.onlinePaid > 0 && (
                                          <tr>
                                            <td colSpan="3"></td>
                                            <td
                                              colSpan={3}
                                              className="text-end font-12 mb-0 pb-0"
                                            >
                                              <b> ₹{globalData?.onlinePaid}</b>{" "}
                                              Paid Via Online
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                    </div>
                                    <div className="row mt-4 align-items-start">
                                      {/* 🔹 LEFT: QR Code */}
                                      <div className="col-6 col-md-2 px-0">
                                        <div className="d-flex flex-column  align-items-md-start">
                                        <span className="px-2 fw-bold pb-0">
                                          Pay Using UPI
                                        </span>
                                        {globalData?.storeSettings?.paymentSettings
                                          ?.upiId && (
                                          <img
                                            src={qrCodeDataUrl}
                                            alt="QR Code"
                                            style={{
                                              width: "90px",
                                              height: "90px",
                                            }}
                                          />
                                        )}
                                        </div>
                                      </div>

                                      {/* 🔹 CENTER: Bank Details */}
                                      <div className="col-6 col-md-6 px-0">
                                        <div style={{ fontSize: "12px" }}>
                                          <strong>Bank Details:</strong>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              Name:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails
                                                ?.beneficiaryName || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              Account #:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails?.accountNo || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              IFSC:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.bankDetails?.ifsc || ""}
                                            </strong>
                                          </div>

                                          <div className="d-flex">
                                            <span style={{ width: "85px" }}>
                                              UPI ID:
                                            </span>
                                            <strong>
                                              {globalData?.storeSettings?.paymentSettings
                                                ?.upiId || ""}
                                            </strong>
                                          </div>
                                        </div>
                                      </div>

                                      {/* 🔹 RIGHT: Signature */}
                                      <div className="col-12 col-md-4 text-end">
                                        {globalData?.storeSettings?.invoiceSettings
                                          ?.signature && (
                                          <img
                                            src={
                                              uRLs.IMAGE_URL +
                                              globalData?.storeSettings?.invoiceSettings
                                                ?.signature
                                            }
                                            alt="Signature"
                                            style={{
                                              width: "120px",
                                              marginBottom: "5px",
                                            }}
                                          />
                                        )}

                                        <div style={{ fontSize: "12px" }}>
                                          Issued By, Signature
                                        </div>
                                      </div>
                                    </div>
                                    <table width="100%">
                                      <tbody>
                                        {terms?.length > 0 && (
                                          <tr>
                                            <td width="100%">
                                              <div className="font-12 text-black text-start fw-600">
                                                Terms & Conditions
                                              </div>
                                              <div className="terms-box font-11">
                                                {terms}
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    {globalData?.storeSettings?.negobillBranding && (
                                      <div className="d-flex justify-content-center">
                                        {" "}
                                        <span>
                                          Powered by{" "}
                                          <strong>NegoBill.com</strong>
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  </InvoiceWrapper>
                              
                         
                        </>
                      ) : (
                        <div className="default-content">
                          <p>No content available for this sale mode.</p>
                        </div>
                      )}
                     
                    </InvoiceLayout>              
                 
              
      </>       
              
  );
};

export default CommercialInvoice;
